import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import Medeverest from "../../img/medeverest.png";
import Prms from "../../img/prms.jpg";
import Agbay from "../../img/agbay.jpg";
import AM from "../../img/am.jpg";
import Mediatrust from "../../img/mtg.jpg";
import { themeContext } from "../../Context";

SwiperCore.use([Autoplay, Pagination]);

const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  const projects = [
    { image: Medeverest, url: "https://med-everest.com" },
    { image: Prms, url: "https://postretirementsystem.000webhostapp.com" },
    { image: Agbay, url: "https://ag-bay.000webhostapp.com" },
    { image: AM, url: "https://americandream-7d815.web.app/" },
    { image: Mediatrust, url: "https://addygeneral.github.io/mediatrustghana/" },
  ];

  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{ color: darkMode ? "white" : "" }}>Recent Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
        autoplay={{ delay: 2000 }} // Set auto slide delay to 2 seconds
        loop={true} // Enable loop to create infinite loop
        pagination={{ clickable: true }}// Add space between pagination and images
      >
        {projects.map((project, index) => (
          <SwiperSlide key={index}>
            <a href={project.url} target="_blank" rel="noopener noreferrer">
              <img src={project.image} alt="" />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Portfolio;
